import { c as _c } from "react/compiler-runtime";
import { alpha, Box, useTheme } from "@mui/material";
import { OverlayScrollbarsComponent, type OverlayScrollbarsComponentRef } from "overlayscrollbars-react";
import type { OverlayScrollbarsComponentProps } from "overlayscrollbars-react";
import React, { type Ref } from "react";
import { appBarSlice } from "#/features/appBar/model/appBarSlice";
import { useAppDispatch } from "#/store/hooks";
const assignViewportRef = (viewportRef: Ref<HTMLDivElement | null> | undefined, viewport: HTMLDivElement | null) => {
  if (!viewportRef) {
    return;
  }
  if (typeof viewportRef === "function") {
    viewportRef(viewport);
    return;
  }
  viewportRef.current = viewport;
};
export type PageScrollContainerProps = {
  children: React.ReactNode;
  isPage?: boolean;
  options?: OverlayScrollbarsComponentProps["options"];
  style?: React.CSSProperties;
  onScroll?: (event: Event) => void;
  /** Receives the OverlayScrollbars viewport element when initialized. */
  viewportRef?: Ref<HTMLDivElement | null>;
};
export const PageScrollContainer: React.FC<PageScrollContainerProps> = t0 => {
  const $ = _c(29);
  const {
    children,
    isPage,
    options: t1,
    style,
    onScroll,
    viewportRef
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {
      scrollbars: {
        autoHide: "scroll"
      },
      overflow: {
        x: "hidden"
      }
    } : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const options = t2;
  const dispatch = useAppDispatch();
  const theme = useTheme();
  let t3;
  if ($[2] !== viewportRef) {
    t3 = instance => {
      const viewport = instance?.osInstance()?.elements().viewport as HTMLDivElement | undefined ?? null;
      assignViewportRef(viewportRef, viewport);
    };
    $[2] = viewportRef;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const overlayScrollbarsRef = t3;
  const t4 = theme.palette.action.hover;
  let t5;
  if ($[4] !== theme.palette.primary.light) {
    t5 = alpha(theme.palette.primary.light, 0.3);
    $[4] = theme.palette.primary.light;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t5) {
    t6 = {
      backgroundColor: t5
    };
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== theme.palette.primary.dark) {
    t7 = alpha(theme.palette.primary.dark, 0.6);
    $[8] = theme.palette.primary.dark;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t7) {
    t8 = {
      backgroundColor: t7
    };
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t6 || $[13] !== t8 || $[14] !== theme.palette.action.hover) {
    t9 = {
      display: "contents",
      ".os-theme-dark.os-scrollbar > .os-scrollbar-track > .os-scrollbar-handle": {
        background: t4,
        "&:hover": t6,
        "&:active": t8
      }
    };
    $[12] = t6;
    $[13] = t8;
    $[14] = theme.palette.action.hover;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== dispatch || $[17] !== isPage || $[18] !== onScroll) {
    t10 = isPage ? {
      scroll: (_, ev) => {
        if (ev.target instanceof Element) {
          dispatch(appBarSlice.actions.setIsScrolled(ev.target.scrollTop > 0));
        }
        onScroll?.(ev);
      },
      destroyed: () => {
        dispatch(appBarSlice.actions.setIsScrolled(false));
      }
    } : undefined;
    $[16] = dispatch;
    $[17] = isPage;
    $[18] = onScroll;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] !== children || $[21] !== options || $[22] !== overlayScrollbarsRef || $[23] !== style || $[24] !== t10) {
    t11 = <OverlayScrollbarsComponent ref={overlayScrollbarsRef} defer={true} style={style} options={options} events={t10}>{children}</OverlayScrollbarsComponent>;
    $[20] = children;
    $[21] = options;
    $[22] = overlayScrollbarsRef;
    $[23] = style;
    $[24] = t10;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== t11 || $[27] !== t9) {
    t12 = <Box sx={t9}>{t11}</Box>;
    $[26] = t11;
    $[27] = t9;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  return t12;
};